import { useEffect, useState } from "react";
import { Table, Badge, Dropdown, Card } from "react-bootstrap";
import { FaTools } from "react-icons/fa";
import Layout from "../Components/Layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { unAcceptedBookings } from "../Redux/Actions/AdminActions";
import PaginationComponent from "../Components/Layout/Pagination";
import moment from "moment";

const url = process.env.REACT_APP_FILE_BASE_URL;

const getStatusBadge = (status) => {
  switch (status) {
    case 0:
      return <Badge bg="warning">N/A</Badge>;
    case 1:
      return <Badge bg="warning">Pending</Badge>;
    case 2:
      return <Badge bg="success">Completd</Badge>;
    case 3:
      return <Badge bg="danger">Cancelled</Badge>;
    default:
      return <Badge bg="secondary">Pending</Badge>;
  }
};

const UnAcceptedBookings = () => {
  const { unAcceptedBookingData } = useSelector((state) => state.usermgt);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation()

  const [page, setpage] = useState(1);
  const [limit, setlimit] = useState(10);

  const pageNo = new URLSearchParams(location?.search).get("page") || page;

  const [flag, setflag] = useState(true);
  const [filter, setFilter] = useState("0");

  const handlePageChange = (pageNumber) => {
    setpage(pageNumber);
    navigate(`/transaction?page=${pageNumber}`)
  };

  useEffect(() => {
    const searchData = {
      page: pageNo,
      limit: limit,
    };
    dispatch(unAcceptedBookings(searchData));
  }, [pageNo, limit, flag, dispatch, filter]);


  return (
    <Layout>
      <div className="filters">
        <div className="inner-filter-field">
          <Card className="transaction-card">
            <Card.Header className="transaction-header p-3">
              <FaTools className="me-2" />
              <h5 className="mb-0">Unaccepted Bookings</h5>
            </Card.Header>
            <Card.Body>
              <Table responsive hover bordered className="transaction-table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Username</th>
                    <th>Booked Service</th>
                    <th>Location</th>
                    <th>Date & Time</th>
                  </tr>
                </thead>
                <tbody>
                  {!unAcceptedBookingData?.transaction?.length ? null : unAcceptedBookingData?.transaction.map((txn, index) => (
                    <tr key={txn.id}>
                      <td>{(index + (pageNo - 1) * limit) + 1}</td>
                      <td>{txn?.userId?.name}</td>
                      <td>{txn?.serviceId?.service_name}</td>
                      <td>{txn?.pickUpAddress || 'N/A'}</td>

                      <td>{moment(txn?.createdAt).format("DD/MM/YYYY HH:mm") || "N/A"}</td>

                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="pagination-section">
                <div className="showing-user">
                  <p>
                    Showing {1 + (pageNo - 1) * limit} -
                    {Math.min(pageNo * limit, unAcceptedBookingData?.totalCount)}{" "}
                    of {unAcceptedBookingData?.totalCount} results
                  </p>
                </div>
                <div className="pagination-block">
                  <PaginationComponent
                    currentPage={pageNo}
                    totalCount={unAcceptedBookingData?.totalCount}
                    limit={limit}
                    onPageChange={handlePageChange}
                  />
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </Layout>
  );
};

export default UnAcceptedBookings;
